import React, { useState } from 'react';

import classNames from 'classnames';

import { Classes, DateTimePicker, Value } from '../../DateTimePicker';

import { useStyles } from './styles';

import { FormHelperText } from 'e100-react-components';
import { Props as DatePickerProps } from 'e100-react-components/lib/components/DatePicker/types';
import { DateTimePickerIcon } from 'shared/components/IconedDateTmePicker/ui/DateTimePickerIcon/DateTimePickerIcon';

export const DateTimePickerRange = ({
  icon,
  hideBorderBottom = false,
  error,
  classes = {},
  variant = 'default',
  ...props
}: DateTimePickerRangeProps) => {
  const {
    defaultEndDay,
    defaultStartDay,
    endDay,
    startDay,
    onChangeStartDay,
    onChangeEndDay,
    maxDate,
    minDate,
    shouldDisableStartDay,
    shouldDisableEndDay,
  } = props;
  const innerClasses = useStyles({ hideBorderBottom, variant });
  const dateRange: [Value, Value] | undefined = startDay && endDay ? [startDay, endDay] : undefined;

  const [openStartDay, setOpenStartDay] = useState<boolean>(false);
  const [openEndDay, setOpenEndDay] = useState<boolean>(false);

  return (
    <>
      <div className={innerClasses.container}>
        <DateTimePickerIcon icon={'todayOutlined'} />
        <div className={innerClasses.firstRoot}>
          <DateTimePicker
            open={openStartDay}
            onOpen={() => setOpenStartDay(true)}
            onClose={() => setOpenStartDay(false)}
            defaultValue={defaultStartDay}
            value={startDay}
            onChange={(date) => {
              if (onChangeStartDay) {
                onChangeStartDay(date);
              }
              setOpenStartDay(false);
              setOpenEndDay(true);
            }}
            classes={{
              datePicker: classNames(innerClasses.datePicker, classes.datePicker),
            }}
            dateRange={dateRange}
            maxDate={maxDate}
            minDate={minDate}
            shouldDisableDate={shouldDisableStartDay}
            fullWidth={false}
          />
        </div>

        <DateTimePicker
          open={openEndDay}
          onOpen={() => setOpenEndDay(true)}
          onClose={() => setOpenEndDay(false)}
          defaultValue={defaultEndDay}
          value={endDay}
          onChange={(date) => {
            if (onChangeEndDay) {
              onChangeEndDay(date);
            }
            setOpenEndDay(false);
          }}
          classes={{
            datePicker: classNames(innerClasses.datePicker, classes.datePicker),
          }}
          dateRange={dateRange}
          maxDate={maxDate}
          minDate={minDate}
          shouldDisableDate={shouldDisableEndDay}
          fullWidth={false}
        />
      </div>
      {error && (
        <FormHelperText
          error
          classes={{
            root: innerClasses.errorMessage,
          }}
        >
          {error}
        </FormHelperText>
      )}
    </>
  );
};

type Variants = 'outlined' | 'default';
export interface DateTimePickerRangeProps {
  classes?: Classes;
  icon?: string;
  hideBorderBottom?: boolean;
  error?: string;
  variant?: Variants;
  defaultStartDay?: string;
  startDay?: string;
  defaultEndDay?: string;
  endDay?: string;
  onChangeStartDay?: (date: string) => void;
  onChangeEndDay?: (date: string) => void;
  minDate?: string;
  maxDate?: string;
  shouldDisableStartDay?: DatePickerProps['shouldDisableDate'];
  shouldDisableEndDay?: DatePickerProps['shouldDisableDate'];
}
